module.exports = __webpack_public_path__ + "img/Picture20.5893306f.png";